module.exports = __webpack_public_path__ + "img/french.1f3c7b50.png";